import React, { useState, useEffect } from "react"
// Not sure why this is required but removing this breaks the styles.
import styled from "styled-components/macro"
import Layout from "../components/layout"
import SEO from "../components/seo"
import Sidebar from "../components/sidebar"
import PrimalExpandedBox from "../components/PrimalBox"
import PrimalItemExpanded from "./ObjectBox"
import {
  HeaderTitle,
  HeaderSubTitle,
  ViewColumn,
  ViewRow,
  Description,
  SubDescription,
  Title,
  GlobalStyle,
} from "../components/styled/styles"
import { ThemeProvider } from "styled-components"
import { lightTheme, darkTheme } from "./themes"
import powers from "../constants/powers"
import relics from "../constants/relics"
import Toggle from "./Toggle"

const Box = styled.div`
  overflow: visible;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  flex: 1;
  width: auto;
  height: auto;
  background: ${({ theme }) => theme.itemBackground};
  border-radius: 34px;
  margin: 0 0 34px 24px;
  padding: 24px;
  transition: 0.2s cubic-bezier(0.17, 0.67, 0.83, 0.67);
  margin: 16px;
`

const PrimalPage = props => {
  const [theme, setTheme] = useState("light")
  const setMode = mode => {
    window.localStorage.setItem("theme", mode)
    setTheme(mode)
  }
  const themeToggler = () => {
    theme === "light" ? setMode("dark") : setMode("light")
  }
  useEffect(() => {
    const localTheme = window.localStorage.getItem("theme")
    localTheme && setTheme(localTheme)
  }, [])
  const [currentSkin, setCurrentSkin] = useState(props.primal.skins[0])
  return (
    <ThemeProvider theme={theme === "light" ? lightTheme : darkTheme}>
      <Layout theme={theme === "light" ? lightTheme : darkTheme}>
        <SEO title={`Primals: ${props.primal.name}`} />
        <GlobalStyle theme={theme === "light" ? lightTheme : darkTheme} />
        <ViewRow
          css={`
            width: 100%;
          `}
        >
          {/** Side bar */}
          <Sidebar theme={theme === "light" ? lightTheme : darkTheme} />
          {/** Right side */}
          <ViewRow>
            <ViewColumn>
              <ViewColumn
                css={`
                  margin: 0 0 48px 24px;
                `}
              >
                <ViewRow
                  css={`
                    justify-content: space-between;
                    align-items: center;
                  `}
                >
                  <ViewColumn>
                    <HeaderTitle theme={theme === "light" ? lightTheme : darkTheme}>CATALYST BLACK WIKI</HeaderTitle>
                    <HeaderSubTitle theme={theme === "light" ? lightTheme : darkTheme}>
                      {props.pageName} / {props.primal.name}
                    </HeaderSubTitle>
                  </ViewColumn>
                  <ViewRow onClick={themeToggler}>
                    <Toggle theme={theme === "light" ? lightTheme : darkTheme} toggleTheme={themeToggler} />
                  </ViewRow>
                </ViewRow>
              </ViewColumn>
              <ViewRow
                css={`
                  @media (max-width: 960px) {
                    flex-wrap: wrap;
                  }
                `}
              >
                <ViewColumn
                  css={`
                    @media (max-width: 960px) {
                      flex: 1;
                    }
                  `}
                >
                  <PrimalExpandedBox
                    primal={props.mask}
                    type={props.pageName}
                    theme={theme === "light" ? lightTheme : darkTheme}
                    data={props.primal}
                    currentSkin={currentSkin}
                    setCurrentSkin={setCurrentSkin}
                  />
                </ViewColumn>

                <ViewColumn>
                  <Title
                    theme={theme === "light" ? lightTheme : darkTheme}
                    css={`
                      text-align: left;
                      margin: 0 0 0 24px;
                      @media (max-width: 960px) {
                        margin: 24px 0 24px 24px;
                      }
                    `}
                  >
                    Lore
                  </Title>
                  <Box theme={theme === "light" ? lightTheme : darkTheme}>
                    <Description theme={theme === "light" ? lightTheme : darkTheme}>
                      {props.primal.description}
                    </Description>
                    <SubDescription style={{ fontSize: "15px" }} theme={theme === "light" ? lightTheme : darkTheme}>
                      {currentSkin.lore}
                    </SubDescription>
                  </Box>
                  <Title
                    theme={theme === "light" ? lightTheme : darkTheme}
                    css={`
                      text-align: left;
                      margin-left: 24px;
                    `}
                  >
                    Powers
                  </Title>
                  <br></br>
                  <ViewRow
                    css={`
                      max-width: 1104px;
                      height: fit-content;
                      flex-wrap: wrap;
                    `}
                  >
                    {powers
                      .filter(p => p.primal === props.primal.name.replace("Luma ", ""))
                      .map((power, index) => (
                        <PrimalItemExpanded
                          type="Powers"
                          key={index}
                          theme={theme === "light" ? lightTheme : darkTheme}
                          data={power}
                          showStats
                        ></PrimalItemExpanded>
                      ))}
                  </ViewRow>

                  <Title
                    theme={theme === "light" ? lightTheme : darkTheme}
                    css={`
                      text-align: left;
                      margin-left: 24px;
                    `}
                  >
                    Relics
                  </Title>
                  <br></br>
                  <ViewRow
                    css={`
                      max-width: 1104px;
                      height: fit-content;
                      flex-wrap: wrap;
                    `}
                  >
                    {relics
                      .filter(p => p.primal === props.primal.name.replace("Luma ", ""))
                      .map((relic, index) => (
                        <PrimalItemExpanded
                          type="Relics"
                          key={index}
                          theme={theme === "light" ? lightTheme : darkTheme}
                          data={relic}
                          showStats
                        ></PrimalItemExpanded>
                      ))}
                  </ViewRow>
                </ViewColumn>
              </ViewRow>
            </ViewColumn>
          </ViewRow>
        </ViewRow>
      </Layout>
    </ThemeProvider>
  )
}

export default PrimalPage
